import type { DashboardInstance } from "../pages/dashboard/mock";

// Why self-serve channel setup is unavailable on this instance, or null when it
// can run. A locked instance says so even while it is still provisioning: the
// lock outlasts provisioning (it lifts after the onboarding call), so "once
// your instance is ready" would promise access sooner than it comes.
export const channelSetupBlockedReason = (
  instance: Pick<DashboardInstance, "status" | "locked"> | null,
): string | null => {
  if (instance === null) return "Available once your instance is ready";
  if (instance.locked === true) return "Available after your onboarding call";
  if (instance.status === "provisioning") return "Available once your instance is ready";
  return null;
};
